module.exports = __webpack_public_path__ + "static/media/tyc.37e78908.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/tyc.png
// module id = 667
// module chunks = 0